import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledDealflowEntitiesGraphsPage = styled(Page)`
  padding: ${props => props.theme.spacing(3)};
  background-color: ${props => props.theme.property('palette.primary.states.hover')};
  
  .DealflowEntitiesGraphsPage {
    &-breakdown {
      aspect-ratio: 424/470;
    }
    &-monthlyBreakdown {
      aspect-ratio: 870/470;
      min-height: ${props => props.theme.layout(360)};
    }
    &-development {
      aspect-ratio: 648/470;
      min-height: ${props => props.theme.layout(360)};
    }
    &-rundown {
      min-height: ${props => props.theme.layout(360)};
    }
    &-latestNews {
      min-height: ${props => props.theme.layout(360)};
    }
    &-news-wrapper {
      display: flex;
      flex-direction: column-reverse;
      gap: ${props => props.theme.layout('3sp')};

      > *:first-child {
        flex-grow: 1;
      }
    }
    &-tasks-wrapper {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('3sp')};

      > *:not(:first-child) {
        flex-grow: 1;
      }
    }
    &-tasks {
      height: ${props => props.theme.layout(226)};
    }
    &-openTasks {
      min-height: ${props => props.theme.layout(440)};
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    padding: ${props => props.theme.spacing(2)};
    
    .DealflowEntitiesGraphsPage {
      &-news-wrapper {
        gap: ${props => props.theme.layout('2sp')};
      }
      &-tasks-wrapper {
        gap: ${props => props.theme.layout('2sp')};
      }
      &-breakdown {
        max-height: ${props => props.theme.layout(484)};
      }
    }
  }

  ${props => props.theme.breakpoints.down('md')} {
    .DealflowEntitiesGraphsPage {
      &-news-wrapper {
        flex-direction: column;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledDealflowEntitiesGraphsPage.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntitiesGraphsPage;
